const underWrittingSummaryInitialState = {
    acceptedHardCheck: false,
    isPending: false,
    hardCheckCompleted: false,
};

export default underWrittingSummaryInitialState;



// WEBPACK FOOTER //
// ./src/app/FormStepper/UnderwrittingSummary/underWrittingSummaryInitialState.js